import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SignupComponent } from "./signup/signup.component";
import { RouterModule, Routes } from "@angular/router";
import { LayoutModule } from "@rubbl-layout";
import { MarketingModule } from "@rubbl-marketing";
import { RubblSharedModule } from "@rubbl-shared";
import { SharedModule } from "app/shared/shared.module";
import { AccountModule } from "@rubbl-account";

const routes: Routes = [
  {
    path: "signup",
    component: SignupComponent,
  },
];

@NgModule({
  declarations: [SignupComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule, RubblSharedModule, MarketingModule, LayoutModule, AccountModule],
})
export class AuthModule {}
